import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useCurrentReservation } from './useCurrentReservation'

export const useReservationsEffect = (cb, deps = []) => {
  const { discount, isNonRefundable, isTripProtection } = useSelector(state => state.payment)
  const productsPurchased = useSelector(state => state.details.productsPurchased)
  const reservationsLength = useSelector(state => state.cart.reservations.length)
  const reservation = useCurrentReservation()
  const { from, rateId, to } = reservation
  const { adults, children, pets, vehicles } = reservation.extras?.guests || {}

  useEffect(() => {
    cb()
  }, [adults, children, discount?.id, from, isNonRefundable, isTripProtection, pets, productsPurchased, rateId,
      reservationsLength, to, vehicles, ...deps])
}
